/**
 * Which meal layout is showing: the vertical list, or the card carousel.
 *
 * The list is the default every time the screen opens. It used to remember
 * the last choice, which sounded helpful and was not: someone who tried the
 * carousel once found the app opening on it for ever afterwards and had no
 * idea why, since nothing on screen said a preference had been stored. The
 * toggle is right there; making it a per-visit choice costs a tap and removes
 * a piece of invisible state.
 */

import { useCallback, useState } from 'react';

export type MealLayout = 'list' | 'carousel';

export const DEFAULT_MEAL_LAYOUT: MealLayout = 'list';

export function useMealLayout(): [MealLayout, () => void] {
  const [layout, setLayout] = useState<MealLayout>(DEFAULT_MEAL_LAYOUT);

  const toggle = useCallback(
    () => setLayout((current) => (current === 'list' ? 'carousel' : 'list')),
    [],
  );

  return [layout, toggle];
}
